import React from "react";
import { Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import AddressLink from "./AddressLink";
import VirtualTourLinks from "./VirtualTourLinks";
import { getCategoryWithoutLocale } from "../utils/filterConfig";

const FacilityCard = ({ facility }) => {
  return (
    <div className="location-list__card">
      <Image
        src={`${process.env.PUBLIC_URL}${facility.image.replace("./", "/")}`}
        fluid="true"
        alt=""
        className="mb-3 location-card-image"
      />

      <h3 className="location-list__card-title">{facility.name}</h3>

      <div className="facility-type__tag">
        {facility.category
          .filter((element) => getCategoryWithoutLocale(element) !== null)
          .map((element) => (
            <span key={element} className="facility-type__tag-element">
              {getCategoryWithoutLocale(element)}
            </span>
          ))}
      </div>

      <p className="location-list__card-address">
        <AddressLink facility={facility} />
      </p>

      <p className="location-list__card-phone">
        <FontAwesomeIcon icon={faPhoneVolume} size="1x" className="link-icon text-green" />
        <a href={`tel:${facility.phone}`}>{facility.phone}</a>
      </p>

      <p className="location-list__card-facility-button m-0">
        {/* {facility.id === 26 ? (
          <span className="coming-soon-link">Coming Soon</span>
        ) : (
          <a href={facility.url} className="btn-gen-dark btn" target={facility.target}>
            View Facility
          </a>
        )} */}

        <a href={facility.url} className="btn-gen-dark btn" target={facility.target}>
          View Facility
        </a>
      </p>

      <span className="location-list__card-tour-links">
        <VirtualTourLinks facility={facility} isPopup={false} />
      </span>
    </div>
  );
};

export default FacilityCard;
